import "./BedCardMobileView.scss"
import moment from "moment";

import blackDownArrow from "../../common/icons/svg/black-down-arrow.svg";
import blackUpArrow from "../../common/icons/svg/black-up-arrow.svg";
import whiteUpArrow from "../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../common/icons/svg/white-down-arrow.svg";

import {
    BED_CARD_VITALS
} from "../../common/constant/common-constants";

import {
    ACTIVE_PARAMETERS,
    PATIENT_TYPE,
    PARAMETER_UNIT_IDS
} from "../../common/ENUMS/PARAMETER_ENUM";

import { MODE } from "../../common/ENUMS/VENTILATOR_MODES_ENUM";
import { alarmBackground } from "../../common/utils/CommonUtils";

const BedCardDesktopView = ({
    props,
    getAlarmPriorityClass,
    handleShowMoreAlarmsClick,
    handleShowMoreVentilatorAlarmsClick,
    showMoreAlarms,
    showMoreVentilatorAlarms,
    ventilatorConnected,
    user_enabled,
    ventilationStatus,
    monitorConnected
}) => {

    let cardHeight = null;
    let cardMinHeight = null;
    const hasVent = !!props.bedDetails?.ventilatorId;
    const hasMonitor = !!props.bedDetails?.Noccarc_patientMonitorId;


    if (!hasVent && !hasMonitor) {
        cardHeight = "5vh";
        cardMinHeight = "60px";
    } else if (hasVent && hasMonitor) {
        cardHeight = "30vh";
        cardMinHeight = "286px";
    } else {
        cardHeight = "18vh";
        cardMinHeight = "176px";
    }



    return (
        <div className="bed-card-mobile-view-box "

            style={{
                height: cardHeight,
                minHeight: cardMinHeight
            }}
            onClick={() => props.handleBedClick(props.bedId)}
        >
            <div className="bed-card-mobile-view-box-header"
                style={{
                    height:
                        !(props.bedDetails?.ventilatorId) &&
                            !props.bedDetails?.Noccarc_patientMonitorId
                            ? "100%"
                            : props.bedDetails?.ventilatorId &&
                                props.bedDetails?.Noccarc_patientMonitorId
                                ? "10%"
                                : "18%"
                }}
            >
                Bed: {props.data.bedName}
            </div>
            {props.bedDetails?.Noccarc_patientMonitorId &&
                <div className="bed-card-mobile-view-box-container"
                    style={{
                        height:
                            props.bedDetails?.ventilatorId ? "40.5%" : "72%"
                    }}
                >
                    <div className="bed-card-mobile-view-box-title">
                        NX5
                        <div className="bed-card-mobile-view-box-machine-no"> {props?.bedDetails?.Noccarc_patientMonitorId?.split('-')[2]}</div>
                    </div>

                    <div className="bed-card-mobile-view-box-alarms">
                        {monitorConnected && props?.alarmData?.length > 0 ?



                            <div className={`alarm-container ${getAlarmPriorityClass(props.alarmData[0])}`}
                                onClick={(event) => handleShowMoreAlarmsClick(event)}
                                id="alarm-display-bar"
                            >
                                <div className="top-alarm-container">
                                    {props.alarmData[0].message}
                                </div>
                                <div className="alarm-number-container">
                                    {props.alarmData.length}
                                    {showMoreAlarms ?
                                        <img src={props.alarmData[0]?.priority === "HIGH" ? whiteUpArrow : blackUpArrow} className="arrow-icon" alt="white up arrow" />
                                        :
                                        <img src={props.alarmData[0]?.priority === "HIGH" ? whiteDownArrow : blackDownArrow} className="arrow-icon" alt="white down arrow" />
                                    }
                                </div>
                                {showMoreAlarms &&
                                    <div className="more-alarm-container">
                                        {
                                            props?.alarmData?.map((alarm, count) => {
                                                if (count > 3) return;
                                                return (
                                                    <div className="alarm more-alarm" key={count}>
                                                        {`${alarm.message}: ${alarm.value != null ? alarm.value : ''}`}
                                                        <span className="alarm-time">{alarm.time && moment(alarm.time).format("HH:mm:ss")}</span>
                                                    </div>);
                                            })
                                        }
                                        <div className="see-all-container" onClick={() => props.handleAlarmMoreClick()}>
                                            See all
                                        </div>
                                    </div>
                                }
                            </div>
                            :
                            <div className="alarm-container no-alarm"
                                id="no-alarm-display-bar"
                            >
                                <div className="top-alarm-container">
                                    No active alarms
                                </div>
                            </div>
                        }

                    </div>

                    <div className="bed-card-mobile-view-box-vitals">
                        <div className={`device-data ${props?.bedDetails?.Noccarc_patientMonitorId ? '' : 'not-connected'}`}>
                            {
                                BED_CARD_VITALS.MONITOR?.map((vital) => {
                                    return (
                                        <div

                                            className={`vital-data-detail ${vital.name === 'BP' ? "wide-field" : ""} ${monitorConnected ? alarmBackground(
                                                (() => {
                                                    if (vital.label === "RR" || vital.label === "HR") {
                                                        return props.vitalData_ECG?.[vital.id]?.alarms;
                                                    }
                                                    else if (vital.label === "SPO2") {
                                                        return props.vitalData_SPO2?.[vital.id]?.alarms;
                                                    } else if (vital.label === "TEMP") {

                                                        if (props.vitalData_TEMP?.[vital.id]?.value) {
                                                            return props.vitalData_TEMP?.[vital.id]?.alarms
                                                        }
                                                        else if (props.vitalData_TEMP?.[vital.backup_id]?.value) {
                                                            return props.vitalData_TEMP?.[vital.backup_id]?.alarms
                                                        }

                                                    } else if (vital.label === "NIBP") {


                                                        const sysAlarms = props.vitalData_NIBP?.[vital.sys_id]?.alarms || [];
                                                        const diaAlarms = props.vitalData_NIBP?.[vital.dia_id]?.alarms || [];
                                                        const meanAlarms = props.vitalData_NIBP?.[vital.mean_id]?.alarms || [];
                                                        return [
                                                            ...sysAlarms,
                                                            ...diaAlarms,
                                                            ...meanAlarms
                                                        ];


                                                    }
                                                    return null; // Fallback if no matching label
                                                })()) : ""}`}
                                            key={vital.name}

                                        >
                                            <div className="vital-name">
                                                {vital.label}
                                            </div>
                                            <div className="vital-data">
                                                {monitorConnected && props?.monitorHeartBeatData ? (
                                                    (() => {
                                                        if (vital.label === "RR" || vital.label === "HR") {
                                                            return props.vitalData_ECG?.[vital.id]?.value ?? "-";
                                                            // return "98"
                                                        }

                                                        else if (vital.label === "SPO2") {
                                                            return props.vitalData_SPO2?.[vital.id]?.value ?? "-"
                                                            // return "98"

                                                        }
                                                        else if (vital.label === "TEMP") {
                                                            if (props.vitalData_TEMP?.[vital.id]?.value) {
                                                                return props.vitalData_TEMP?.[vital.id]?.value
                                                                    ? props.vitalData_TEMP[vital.id].value.toFixed(1)
                                                                    : "-"
                                                                // return "98"
                                                            } else {
                                                                return props.vitalData_TEMP?.[vital.backup_id]?.value
                                                                    ? props.vitalData_TEMP[vital.backup_id].value.toFixed(1)
                                                                    : "-"
                                                                // return "98"

                                                            }


                                                        }
                                                        else if (vital.label === "NIBP") {
                                                            return `${props.vitalData_NIBP?.[vital.sys_id]?.value ?? "-"}/${props.vitalData_NIBP?.[vital.dia_id]?.value ?? "-"}`
                                                            // return "120/98"
                                                        }
                                                        return null;
                                                    })()
                                                ) : (
                                                    "-"
                                                )}
                                                <span className="unit">{vital.unit}</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            }
            {props.bedDetails?.ventilatorId &&
                <div className="bed-card-mobile-view-box-container"

                    style={{
                        height:
                            props.bedDetails?.Noccarc_patientMonitorId ? "40.5%" : "72%"
                    }}>

                    <div className="bed-card-mobile-view-box-title">
                        V730i: {
                            ventilatorConnected && user_enabled
                                ? `${MODE[props?.ventilatorPatientModeAlarmProfileData?.modeId]?.modeName || '--'} ${PATIENT_TYPE[props?.ventilatorPatientModeAlarmProfileData?.patientType] || ''}`
                                : '-'
                        }
                        <div className="bed-card-mobile-view-box-machine-no"> {props?.bedDetails?.ventilatorId?.substr(-5)}</div>
                    </div>

                    <div className="bed-card-mobile-view-box-alarms">
                        {ventilatorConnected && user_enabled && ventilationStatus && props?.ventilatorAlarmData?.length > 0 ?
                            <div className={`alarm-container ${getAlarmPriorityClass(props.ventilatorAlarmData[0])}`}
                                onClick={(event) => handleShowMoreVentilatorAlarmsClick(event)}
                                id="alarm-display-bar"
                            >
                                <div className="top-alarm-container">
                                    {props.ventilatorAlarmData[0].name}
                                </div>
                                <div className="alarm-number-container">
                                    {props.ventilatorAlarmData.length}
                                    {showMoreVentilatorAlarms ?
                                        <img src={props.ventilatorAlarmData[0].priority?.toLocaleUpperCase() === "HIGH" ? whiteUpArrow : blackUpArrow} className="arrow-icon" alt="white up arrow" />
                                        :
                                        <img src={props.ventilatorAlarmData[0].priority?.toLocaleUpperCase() === "HIGH" ? whiteDownArrow : blackDownArrow} className="arrow-icon" alt="white down arrow" />
                                    }
                                </div>
                                {showMoreVentilatorAlarms &&
                                    <div className="more-alarm-container">
                                        {
                                            props?.ventilatorAlarmData?.map((alarm, count) => {
                                                if (count > 3) return;
                                                return (
                                                    <div className="alarm more-alarm" key={count}>
                                                        {alarm.name}
                                                        <span className="alarm-time">{alarm.time && moment(alarm.time, "YYYYMMDDHHmmss").format("HH:mm:ss")}</span>
                                                    </div>);
                                            })
                                        }
                                        <div className="see-all-container" onClick={() => props.handleAlarmMoreClick()}>
                                            See all
                                        </div>
                                    </div>
                                }
                            </div>
                            :
                            <div className="alarm-container no-alarm"
                                id="no-alarm-display-bar"
                            >
                                <div className="top-alarm-container">
                                    No active alarms
                                </div>
                            </div>
                        }
                    </div>

                    <div className="bed-card-mobile-view-box-vitals">
                        <div className={`device-data ${props?.bedDetails?.ventilatorId ? '' : 'not-connected'}`}>
                            {BED_CARD_VITALS.VENTILATOR.map((vital) => {
                                const vitalData = Object.values(props?.ventilatorData?.ventilatorVitalData?.basic_params || {})
                                    .find(p => p?.id === vital?.id);

                                const hasValidUnit = PARAMETER_UNIT_IDS?.[vitalData?.unit]?.UNIT != null;

                                const alarmClass = hasValidUnit && ventilatorConnected && user_enabled && ventilationStatus && vitalData?.alarms?.length
                                    ? alarmBackground(vitalData.alarms)
                                    : "";

                                const formatValue = (num) => {
                                    if (num == null || isNaN(num)) return "--";

                                    const truncated = num * 100;

                                    if (truncated % 100 === 0) {
                                        return num.toString();
                                    }
                                    else if (truncated % 10 === 0) {

                                        const numStr = num.toString();
                                        const [intPart, decPart] = numStr.split(".");
                                        return intPart + "." + (decPart ? decPart[0] : "0");
                                    }
                                    else {

                                        const numStr = num.toString();
                                        const [intPart, decPart] = numStr.split(".");
                                        return intPart + "." + (decPart ? decPart.slice(0, 2) : "00");
                                    }
                                };


                                const title = ACTIVE_PARAMETERS?.[vital?.id]?.TITLE ?? "-";
                                const unit = hasValidUnit ? PARAMETER_UNIT_IDS?.[vitalData?.unit]?.UNIT ?? "-" : "-";


                                const value = hasValidUnit && vitalData?.value != null
                                    ? formatValue(vitalData.value)
                                    : "-";

                                return (
                                    <div
                                        key={vital?.id}
                                        className={`vital-data-detail ${vital?.id === 104008 ? "wide-field" : ""} ${alarmClass}`}
                                    >
                                        <div className="vital-name">{title}</div>
                                        <div className="vital-data">
                                            {ventilatorConnected && user_enabled && ventilationStatus ? value : "-"}
                                            <div className="unit">{unit}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                </div>
            }

        </div>
    );
};

export default BedCardDesktopView;
